const fetch = require("node-fetch");

const FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSe8Y0JTHsyHjUfXAbXdApgggD0KolHnGzU0jOkipiMYp4KX5Q/formResponse";
const FIELD_ID = "entry.2070436417";

async function logToGoogleSheet(message) {
 try {
   const timestamp = new Date().toISOString();
  const data = new URLSearchParams();
  data.append(FIELD_ID, `[${process.env.NODE_ENV}] [${timestamp}] ${message}`);

  await fetch(FORM_URL, { method: "POST", body: data });
 } catch (error) {
   console.error("Error logging to Google Sheets:", error);
 }
}

// Example usage
/* logToGoogleSheet("App started successfully");
logToGoogleSheet("User logged in"); */

module.exports = logToGoogleSheet;